import { ReactNode, Suspense, lazy } from 'react';
import styled from 'styled-components';

import snowUrl from './assets/snow.png';

const SnowBackground = lazy(async () =>
  import('@sorare/trois/src/components/SnowBackground').then(module => ({
    default: module.SnowBackground,
  }))
);

const SnowPicture = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${snowUrl});

  background-size: cover;
  background-color: var(--c-nd-50-opaque);
`;

const Wrapper = styled.div`
  background-image: linear-gradient(
    to bottom,
    rgba(255, 43, 43, 0.2) 0%,
    rgba(16, 16, 16, 0.2) 100%
  );
  background-size: cover;
  background-color: var(--c-nd-50-opaque);

  position: relative;
  isolation: isolate;
`;

const SnowWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

const Snow = () => (
  <SnowWrapper>
    <Suspense fallback={<SnowPicture />}>
      <SnowBackground fallback={<SnowPicture />} />
    </Suspense>
  </SnowWrapper>
);

type Props = { children: ReactNode } & React.JSX.IntrinsicElements['div'];

export const NeonChristmasBackground = ({ children, ...props }: Props) => {
  return (
    <Wrapper {...props}>
      <Snow />
      {children}
    </Wrapper>
  );
};
